export const environment = {
  baseUri: 'https://ilasy-dev.fanasina.com',
  baseUriRegistration: 'https://ilasy-dev.fanasina.com/registration?link=',
  production: false,
  maintenance: false,
  environmentName: 'dev',
  backendUrl: 'https://ilasy-dev-api.fanasina.com',
  oidc: {
    issuer: 'https://ilasy-authentik.fanasina.com/application/o/ilasy-dev/',
    clientId: 'wOaTXFbCbRH6J0AZ3DowSfB6TgkkqNS52B02rMeM',
    scope: 'openid profile email offline_access',
    redirectUri: 'https://ilasy-dev.fanasina.com/auth/callback',
    postLogoutRedirectUri: 'https://ilasy-dev.fanasina.com',
    requireHttps: true,
  },
};

export type AppEnvironment = typeof environment;
